import script from "./LanguageSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts&setup=true"

import "./LanguageSelector.vue?vue&type=style&index=0&id=27ca6193&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ca6193"]])

export default __exports__